import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { ISO_REQUEST_SEARCH_START_LOADING, ISO_REQUEST_SEARCH_END_LOADING, ISO_REQUEST_SEARCH_LOADED, SET_ISO_REQUEST_FILTER } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_NOTIFY_START_LOADING, ISO_REQUEST_NOTIFY_END_LOADING, ISO_REQUEST_NOTIFY_LOADED, SET_ISO_REQUEST_NOTIFY_FILTER } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_START_LOADING, ISO_REQUEST_END_LOADING, ISO_REQUEST_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_INVOICE_START_LOADING, ISO_REQUEST_INVOICE_END_LOADING, ISO_REQUEST_INVOICE_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_ITEM_START_LOADING, ISO_REQUEST_ITEM_END_LOADING, ISO_REQUEST_ITEM_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_RELATED_START_LOADING, ISO_REQUEST_RELATED_END_LOADING, ISO_REQUEST_RELATED_LOADED } from "../constants/IsoRequestConstants";
import { ISO_REQUEST_CERTIFICATE_START_LOADING, ISO_REQUEST_CERTIFICATE_END_LOADING, ISO_REQUEST_CERTIFICATE_LOADED } from "../constants/IsoRequestConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        mineOnly: true,
        sortBy: "last_action_date",
        sortOrder: "DESC"
    },
    notifyList: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    notifyFilter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        dateType: "",
        dateValue: [],
        state: "Upcoming",
        notify: "1"
    },
    loadingFBO: false,
    fbo: null,
    loadingInvoice: false,
    invoiceFBO: null,
    loadingItem: false,
    itemList: [],
    loadingRelated: false,
    relatedList: [],
    loadingCertificate: false,
    certificate: null,
};

const IsoRequestReducer = (state = initialState, action) => {
    switch(action.type) {
        case ISO_REQUEST_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case ISO_REQUEST_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case ISO_REQUEST_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_ISO_REQUEST_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case ISO_REQUEST_NOTIFY_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case ISO_REQUEST_NOTIFY_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case ISO_REQUEST_NOTIFY_LOADED:
            return {
                ...state,
                notifyList: action.payload
            };
        case SET_ISO_REQUEST_NOTIFY_FILTER:
            return {
                ...state,
                notifyFilter: action.payload
            };
        case ISO_REQUEST_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case ISO_REQUEST_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case ISO_REQUEST_LOADED:
            return {
                ...state,
                fbo: action.payload
            };  
        case ISO_REQUEST_INVOICE_START_LOADING:
            return {
                ...state,
                loadingInvoice: true
            };
        case ISO_REQUEST_INVOICE_END_LOADING:
            return {
                ...state,
                loadingInvoice: false
            };
        case ISO_REQUEST_INVOICE_LOADED:
            return {
                ...state,
                invoiceFBO: action.payload
            };        
        case ISO_REQUEST_ITEM_START_LOADING:
            return {
                ...state,
                loadingItem: true
            };
        case ISO_REQUEST_ITEM_END_LOADING:
            return {
                ...state,
                loadingItem: false
            };
        case ISO_REQUEST_ITEM_LOADED:
            return {
                ...state,
                itemList: action.payload
            };
        case ISO_REQUEST_RELATED_START_LOADING:
            return {
                ...state,
                loadingRelated: true
            };
        case ISO_REQUEST_RELATED_END_LOADING:
            return {
                ...state,
                loadingRelated: false
            };
        case ISO_REQUEST_RELATED_LOADED:
            return {
                ...state,
                relatedList: action.payload
            };
        case ISO_REQUEST_CERTIFICATE_START_LOADING:
            return {
                ...state,
                loadingCertificate: true
            };
        case ISO_REQUEST_CERTIFICATE_END_LOADING:
            return {
                ...state,
                loadingCertificate: false
            };
        case ISO_REQUEST_CERTIFICATE_LOADED:
            return {
                ...state,
                certificate: action.payload
            };
        default:
            return state;
    }
}

export default IsoRequestReducer;